import { httpsCallable } from "firebase/functions";
import { functionsClient } from "./firebase";

export type ReportReason =
  | "sexual_content"
  | "minor_safety"
  | "violence"
  | "harassment"
  | "hate"
  | "spam"
  | "impersonation"
  | "off_topic"
  | "privacy"
  | "other";

async function submitReport(data: Record<string, unknown>) {
  const callable = httpsCallable(functionsClient, "submitReport");
  return callable(data);
}

export function reportPost(params: { reporterUid: string; postId: string; reason: ReportReason; details?: string }) {
  return submitReport({ targetType: "post", targetId: params.postId, postId: params.postId, reason: params.reason, details: params.details });
}

export function reportComment(params: { reporterUid: string; postId: string; commentId: string; reason: ReportReason; details?: string }) {
  return submitReport({ targetType: "comment", targetId: params.commentId, postId: params.postId, reason: params.reason, details: params.details });
}

export function reportUser(params: { reporterUid: string; targetUid: string; reason: ReportReason; details?: string }) {
  return submitReport({ targetType: "user", targetId: params.targetUid, reason: params.reason, details: params.details });
}
